import React from "react"

import { localizer } from '../../../../Translator'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'

import { BoxSelector } from "../../../common/BoxSelector"


export class FeatureModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // to OCR: rectangle in draft
      document: null,

      // OCR errors
      draftError: null,
      detectReferenceError: null,
      
    }
  }
  componentDidMount() {
    this.setState({
      document: this.props.document,
      referenceLeft: this.props.left,
      referenceTop: this.props.top,
      referenceWidth: this.props.width,
      referenceHeight: this.props.height,
    })
  }
  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return

    this.setState({
      document: this.props.document,
      referenceLeft: this.props.left,
      referenceTop: this.props.top,
      referenceWidth: this.props.width,
      referenceHeight: this.props.height,
    })
  }
  /*selecting a new box set the new coordinates*/
  handleReferenceBoxChange = (l, t, w, h) => {
    this.setState({
      referenceLeft: l,
      referenceTop: t,
      referenceWidth: w,
      referenceHeight: h,
    })
  }

  handleCloseModal = () => {
    this.props.doCloseOcrReferenceModal()
  }
  handleAcceptReference = () => {
    this.props.handleAcceptReference(this.state.referenceLeft, this.state.referenceTop, this.state.referenceWidth, this.state.referenceHeight)
  }

  render() {
    let left = this.state.referenceLeft
    let top = this.state.referenceTop
    let width = this.state.referenceWidth
    let height = this.state.referenceHeight
    return (
      <React.Fragment>
        {/*  ORC Reference Modal  */}
        <Dialog
          open={this.props.openModal}
          onClose={this.props.handleCloseModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"lg"}
        >
          <DialogContent dividers={true} className="p-0">
            <Grid container item md={12}>
              <Grid container item md={4} className="bg-secondary" style={{ display: "block", padding: "40px" }}>
                <Grid item md={12}>
                  <Typography className="typography-generic">{localizer.BoxSelectorRerence}</Typography>
                </Grid>
                <Grid item md={12}>
                  <ol>
                    <li className="typography-generic">{localizer.BoxSelectorRerenceStepOne}</li>
                    <li className="typography-generic">{localizer.BoxSelectorRerenceStepTwo}</li>
                    <li className="typography-generic">{localizer.BoxSelectorReferenceStepThree}</li>
                  </ol>
                </Grid>
              </Grid>
              <Grid container item md={8}>
                {/*  <Grid item md={12} className="pt-20 pd-20">
                  <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom mr-10" onClick={this.props.handleCloseModal}></i>
                </Grid> */}
                <Grid item md={12} className="ocr-single-shipment-button">
                  <Typography className="typography-generic bigweight ocr-title-button-modal">{localizer.OcrProcessReferenceTitle}<i className="fa-solid fa-circle-xmark closeoutlinedicon-custom mr-10" onClick={this.props.handleCloseModal}></i></Typography>
                </Grid>
                <Grid item md={12} className="text-align-center mt-20 mb-20">
                  {this.state.document !== null &&
                    <BoxSelector
                      imageSrc={"data:image/png;base64, " + this.state.document}
                      canvasWidth={750}
                      canvasHeight={900}
                      left={left}
                      top={top}
                      width={width}
                      height={height}
                      onChanged={(l, t, w, h) => this.handleReferenceBoxChange(l, t, w, h)}
                    />
                  }
                </Grid>
                <Grid item md={12} className="text-align-left pb-20 pr-20">
                  <Button className="button-generic dialog-primary" variant="contained" onClick={this.handleAcceptReference}>{localizer.Accept}</Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/features/FeatureModal.js